import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getMountingSurfaceOptions } from '../../../helpers/mountingSurface';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  mountingSurface: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (mountingSurface, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      mountingSurface,
    },
  });
};

export const MountingSurface = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { mountingSurface },
  } = state.context;
  const mountingSurfaceOptions = getMountingSurfaceOptions(state.context);

  if (
    isCurrentState('mountingSurface', state) &&
    mountingSurfaceOptions.length === 0
  ) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Mounting surface</Heading>
      <Selector>
        {mountingSurfaceOptions.map(option => {
          return (
            <SelectorItem
              isSelected={option === mountingSurface}
              onClick={onClick(option, send)}
              key={option}
            >
              {option}
            </SelectorItem>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
